import { Component, type ReactNode } from "react";

/**
 * Around the upload dialog, whose code loads when it is needed. Left to
 * the page's own boundary a failed load would take the whole page with it,
 * and both boxes with the page. Here it goes alone, and says so.
 */
export default class UploadGuard extends Component<
    { onFailed: () => void; children: ReactNode },
    { failed: boolean }
> {
    state = { failed: false };

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(): void {
        this.props.onFailed();
    }

    render(): ReactNode {
        return this.state.failed ? null : this.props.children;
    }
}
